<ion-header class="ion-no-border">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="close()">
        <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>
      Address book
      @if (!loading && cart && cart.organisation) {
        <p class="subtitle">{{cart.organisation.title}}</p>
      }
      @if (!loading && cart && !cart.organisation && cart.person) {
        <p class="subtitle">
          @if (cart.person.full_name) {
            <span>{{cart.person.full_name}} (#{{cart.person.number}})</span>
          }
          @if (!cart.person.full_name) {
            <span>#{{cart.person.number}}</span>
          }
        </p>
      }
    </ion-title>
    @if (online && !loading) {
      <ion-buttons slot="end">
        @if ((person && permissionService.isPermitted('pos-people-shipping-addresses-add-shipping-address')) || (organisation && permissionService.isPermitted('pos-organisations-shipping-addresses-add-shipping-address'))) {
          <ion-button (click)="presentAddShippingAddressModal()">
            <fa-icon [icon]="['far', 'plus']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
          </ion-button>
        }
      </ion-buttons>
    }
  </ion-toolbar>

  <ion-toolbar>
    <ion-searchbar placeholder="Name, organisation or address" debounce="500" [(ngModel)]="query" (ionInput)="searchAddresses()"></ion-searchbar>
  </ion-toolbar>

</ion-header>

<ion-content>

  @if (online && !loading && visible_addresses && visible_addresses.length != 0) {
    <table class="datatable full-bleed">
      <thead>
        <tr>
          <th class="no-wrap">Address type</th>
          <th class="no-wrap">Address</th>
        </tr>
      </thead>
      <tbody>
        @for (address of visible_addresses; track address; let i = $index) {
          <tr class="ion-activatable ripple-parent button-row" (click)="select(i)">
            <td class="if-empty-na">
              <span>{{address.type}}</span>
            </td>
            <td style="display: flex; justify-content: space-between;">
              <div>
                @if (address.first_name || address.last_name) {
                  <span>
                    @if (address.first_name && !address.last_name) {
                      {{address.first_name}}
                    }
                    @if (!address.first_name && address.last_name) {
                      {{address.last_name}}
                    }
                    @if (address.first_name && address.last_name) {
                      {{address.first_name}} {{address.last_name}}
                    }
                    <br>
                    </span>
                  }
                  @if (address.organisation_title) {
                    <span>{{address.organisation_title}}<br></span>
                  }
                  @if (address.premises) {
                    <span>{{address.premises}}<br></span>
                  }
                  @if (address.line_1) {
                    <span>{{address.line_1}}<br></span>
                  }
                  @if (address.line_2) {
                    <span>{{address.line_2}}<br></span>
                  }
                  @if (address.locality) {
                    <span>{{address.locality}}<br></span>
                  }
                  @if (address.subdivision) {
                    <span>{{address.subdivision}}<br></span>
                  }
                  @if (address.postal_code) {
                    <span>{{address.postal_code}}<br></span>
                  }
                  @if (address.country_title) {
                    <span>{{address.country_title}}</span>
                  }
                </div>
                @if (address.type == 'Shipping address' && ((address.entity_type == 'person' && (permissionService.isPermitted('pos-people-shipping-addresses-edit-shipping-address') || permissionService.isPermitted('pos-people-shipping-addresses-delete-shipping-address'))) || (address.entity_type == 'organisation' && (permissionService.isPermitted('pos-organisations-shipping-addresses-edit-shipping-address') || permissionService.isPermitted('pos-organisations-shipping-addresses-delete-shipping-address'))))) {
                  <div style="white-space: nowrap; align-content: center; text-align: right;">
                    <ion-buttons slot="end">
                      <ion-button (click)="addressOptionsPopover($event,address)">
                        <fa-icon [icon]="['far', 'ellipsis-v']" size="lg" slot="end" style="padding: 10px 20px;"></fa-icon>
                      </ion-button>
                    </ion-buttons>
                  </div>
                }
              </td>
              <!-- NOTE: this is required for the ripple effect on IOS -->
              <div class="ripple-pseudo-element">
                <ion-ripple-effect></ion-ripple-effect>
              </div>
            </tr>
          }
        </tbody>
      </table>
    }

    @if (!loading && visible_addresses && visible_addresses.length != 0) {
      <ion-infinite-scroll threshold="100px" (ionInfinite)="showMoreVisibleAddresses($event)">
        <ion-infinite-scroll-content loadingSpinner="crescent" loadingText="Loading"></ion-infinite-scroll-content>
      </ion-infinite-scroll>
    }

    @if (online && !loading && visible_addresses && visible_addresses.length == 0) {
      <ion-grid class="nothing-found">
        <ion-row class="ion-align-items-center ion-justify-content-center">
          <ion-col>
            <p>
              <fa-icon [icon]="['fal', 'address-book']" size="6x"></fa-icon>
              <span>No addresses found</span>
            </p>
          </ion-col>
        </ion-row>
      </ion-grid>
    }

    <!-- skeleton text -->
    @if (loading) {
      <table class="datatable">
        <thead>
          <tr>
            <th><ion-skeleton-text [animated]="true" style="width: 140px; height: 20px"></ion-skeleton-text></th>
            <th><ion-skeleton-text [animated]="true" style="width: 140px; height: 20px"></ion-skeleton-text></th>
            <th><ion-skeleton-text [animated]="true" style="width: 140px; height: 20px"></ion-skeleton-text></th>
          </tr>
        </thead>
        <tbody>
          @for (n of [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19]; track n) {
            <tr>
              <td><ion-skeleton-text [animated]="true" style="width: 120px; height: 15px"></ion-skeleton-text></td>
              <td><ion-skeleton-text [animated]="true" style="width: 120px; height: 15px"></ion-skeleton-text></td>
              <td>
                <ion-skeleton-text [animated]="true" style="width: 120px; height: 15px"></ion-skeleton-text>
                <ion-skeleton-text [animated]="true" style="width: 120px; height: 15px"></ion-skeleton-text>
                <ion-skeleton-text [animated]="true" style="width: 120px; height: 15px"></ion-skeleton-text>
                <ion-skeleton-text [animated]="true" style="width: 120px; height: 15px"></ion-skeleton-text>
                <ion-skeleton-text [animated]="true" style="width: 120px; height: 15px"></ion-skeleton-text>
                <ion-skeleton-text [animated]="true" style="width: 120px; height: 15px"></ion-skeleton-text>
              </td>
            </tr>
          }
        </tbody>
      </table>
    }

  </ion-content>

